export default "__VITE_ASSET__HPm8W4AB__"